// src/pages/AgentPage.js
import React from 'react';
import Agent from '../components/Agent';

const AgentPage = () => {
  return <Agent />;
};

export default AgentPage;